import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import clsx from 'clsx';
import loadingAnimation from '@smart-tv/scaffold/lottie/loading-norlys.json';

import styles from './progress-spinner.module.scss';
import { Icon, Props as IconProps } from '@smart-tv/components/icons/icon';

interface Props {
  size?: IconProps['size'] | number;
  className?: string;
  icon?: boolean;
}

export const ProgressSpinner: React.FC<Props> = (props: Props) => {
  const { size, className, icon } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const animation = lottie.loadAnimation({
      container: containerRef.current,
      animationData: loadingAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true
    });

    return () => animation.destroy();
  }, []);

  if (icon) {
    return (
      <Icon
        type="div"
        ref={containerRef}
        size={size}
        className={clsx(styles['icon-spinner'], className)}
        aria-label="Loading"
      />
    );
  }
  return typeof size === 'number' ? (
    <div
      ref={containerRef}
      role="progressbar"
      aria-label="Loading"
      className={className}
      style={{ width: size, height: size }}
    />
  ) : (
    <div
      ref={containerRef}
      role="progressbar"
      aria-label="Loading"
      className={clsx(styles['spinner'], className)}
    />
  );
};
export default React.memo(ProgressSpinner);
